import styled from '@styled';

export const StyledNote = styled('div')`
  display: flex;
  flex-direction: column;
  background-color: var(--yellowColor);
  border-radius: .5rem;
  border: 1px solid var(--lightRedColor);
  color: var(--white);
  font-size: .85rem;
  padding: .5rem 1rem .5rem 2.5rem;
  position: relative;
  text-shadow: 0 0 4px rgba(0, 0, 0, .6);
  width: fit-content;
  margin: 1.5rem 0;

  &:before {
    align-items: center;
    border-radius: 50%;
    border: 1px solid var(--white);
    content: "!";
    display: flex;
    font-size: 1rem;
    font-weight: bold;
    height: 1.35rem;
    justify-content: center;
    left: .65rem;
    padding-right: 1px;
    padding-top: 2px;
    position: absolute;
    top: calc((100% - 1.35rem) / 2);
    width: 1.35rem;
  }
`;
